
import * as constants from '../Constatnts'
import axios from 'axios';

export function getLoyaltyType() {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;

      const response = await axios.get(
        constants.API_URL + "/getloyaltytype",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      let loyaltyTypes = [];

      if (response.data.code === "0") {
        loyaltyTypes = response.data.loyaltyTypes;
      }

      return loyaltyTypes;
    } catch (error) {
      return [];
    }
  };
}

export function deleteLoyaltyType(key) {
  return async (dispatch, getState) => {
    const token = getState().user.uat;

    const response = await axios.delete(
      constants.API_URL + `/loyaltytype/${key}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (response.data.code === "0") {
      return true;
    } else {
      return false;
    }
  };
}


export function saveLoyaltyType(loyaltyType, key) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      let response = {};

      if (key !== "") {
        // Update existing account
        response = await axios.put(
          `${constants.API_URL}/loyaltytype/${key}`,
          loyaltyType,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      } else {
        // Create new account
        response = await axios.post(
          `${constants.API_URL}/loyaltytype`,
          loyaltyType,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      }

      if (response.data.code === "0") {
        if (key) {
          return key;
        } else {
          return response.data.loyalty.key;
        }
      }

      return null;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}





export function getLoyaltyTypeDetails(key) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      const response = await axios.get(
        `${constants.API_URL}/loyaltytype/${key}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data.loyaltyType;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}


export function saveLoyaltySetup(loyaltySetup) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      const response = await axios.post(
        `${constants.API_URL}/loyaltysetup`,
        loyaltySetup,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
       return response.data.data.key || null
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}


export function getLoyaltySetupDetails(registraitonID) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      const response = await axios.get(
        `${constants.API_URL}/getloyaltysetup`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
       return response.data.LoyaltySetup || null
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}



export function getCustomerLoyaltyPoints(customerID) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      const response = await axios.get(
        `${constants.API_URL}/getloyaltycustomer/${customerID}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
       return response.data.LoyaltyCustomer[0] || null
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}



export function getTotalLoyaltyCustomer(registrationID) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      const response = await axios.get(
        `${constants.API_URL}/reports/loyalty/totalcustomer/${registrationID}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
       return { totalItemsCount:response.data.totalItemsCount, searchResult:response.data.searchResult }
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}

export function getLoyaltyTypeCustomerCount(registrationID) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      const response = await axios.get(
        `${constants.API_URL}/reports/loyalty/type/${registrationID}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
       return { totalItemsCount:response.data.totalItemsCount, searchResult:response.data.searchResult }
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}


export function getLoyaltyPointEarnAndBurn(registrationID) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      const response = await axios.get(
        `${constants.API_URL}/reports/loyalty/point/${registrationID}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
       return { totalItemsCount:response.data.totalItemsCount, searchResult:response.data.searchResult }
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}



export function getMonthWiseLoyaltyPointEarnAndBurn(registrationID) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      const response = await axios.get(
        `${constants.API_URL}/reports/loyalty/monthaly/${registrationID}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
       return { totalItemsCount:response.data.totalItemsCount, searchResult:response.data.searchResult }
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}
